<template>
  <el-dialog :visible.sync="innerVisible" :title="title" width="600px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="100px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="statusLabel">
            <el-select
              v-model="status"
              no="status"
              :placeholder="' '"
              :clearable="false"
              size="mini"
              @change="statusChangeHandler"
            >
              <el-option
                v-for="(item,index) in businessStatus"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" />
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')">
            <el-input v-model="remark" type="textarea" no="remark" :rows="4" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" no="confirm" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CooperateStatusDialog',
  props: {
    visible: { type: Boolean, required: true },
    statusTypeDesc: { type: String, default: '' },
    updateStateCallBack: { type: Function, default: () => (null) }
  },
  data() {
    return {
      status: 0,
      remark: '',
      innerVisible: false
    }
  },
  computed: {
    businessStatus() {
      return SystemConstants.BUSINESS_STATUS
    },
    title() {
      return this.statusTypeDesc
    },
    statusLabel() {
      return this.statusTypeDesc
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async init() {
      this.status = SystemConstants.BUSINESS_STATUS_FINISHED.code
      this.remark = ''
    },
    statusChangeHandler(val) {
      this.status = val
    },
    handleSubmit() {
      const result = {}
      result.status = this.status
      result.remark = this.remark
      this.updateStateCallBack(result)
      this.handleClose()
    },
    handleClose() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
.cargo-form-dialog{
  .el-dialog{
    &__header,&__body,&__footer{
      padding:10px 15px!important;
    }
    &__title{
      vertical-align: middle;
    }
    &__headerbtn{
      top:15px;
      right:15px;
    }
  }
}
.cargo-form{
  .el-form-item {
    &.red-input{
      .el-input__inner{
        color: #E9650E;
      }
    }
    &__content{
      width: auto!important;
    }
    &.label-none {
      .el-form-item__content{
        margin-left: 0;
      }
    }
  }
}
</style>
